import Api from '@/services/Api'

const URL = 'bancos/movimiento-bancario/';
const ACTION_AGREGAR_DETALLE = 'agregar_detalle';
const ACTION_AGREGAR_CONCILIACION = 'conciliar_movimiento';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';

export default {

    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },

    getById(id) {
        return Api().get(URL + id)
    },

    save(params) {
        let url = URL;
        if ('pk' in params) {
            params.id = params.pk;
            return Api().put(url + params.pk + '/', params)
        }
        return Api().post(url, params)
    },

    abrir(id) {

        return Api().post(`${URL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${URL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${URL}${id}/${ACTION_ANULAR}/`);

    },

    agregar_detalle(id, params) {
        return Api().post(`${URL}${id}/${ACTION_AGREGAR_DETALLE}/`, params);

    },

    conciliar_movimiento(id, params) {
        return Api().post(`${URL}${id}/${ACTION_AGREGAR_CONCILIACION}/`, params);

    },

}